import { ReactNode } from 'react'
import { cn } from '@/lib/utils'

interface DetailSectionProps {
  children: ReactNode
  className?: string
}

interface DetailSectionHeaderProps {
  title: string
  subtitle?: string
  badge?: ReactNode
  actions?: ReactNode
  className?: string
}

interface DetailSectionBodyProps {
  children: ReactNode
  className?: string
}

function DetailSectionRoot({ children, className }: DetailSectionProps) {
  return <div className={cn('space-y-3', className)}>{children}</div>
}

function DetailSectionHeader({
  title,
  subtitle,
  badge,
  actions,
  className,
}: DetailSectionHeaderProps) {
  return (
    <div className={cn('', className)}>
      <div className="flex flex-col items-start justify-between gap-2 sm:flex-row sm:items-center">
        <div className="flex items-center gap-2 whitespace-nowrap">
          <h2 className="text-base font-semibold text-gray-900 sm:text-lg">
            {title}
          </h2>
          {badge}
        </div>
        {actions}
      </div>
      {subtitle && <div className="mt-1 text-xs text-gray-500">{subtitle}</div>}
    </div>
  )
}

function DetailSectionBody({ children, className }: DetailSectionBodyProps) {
  return <div className={cn('', className)}>{children}</div>
}

export const DetailSection = Object.assign(DetailSectionRoot, {
  Header: DetailSectionHeader,
  Body: DetailSectionBody,
})
